// extracted by mini-css-extract-plugin
export default {"root":"MaskActions_root__7oVzc","buttons":"MaskActions_buttons__6lz3e"};